import { useComplianceExperience } from '~/hooks/useComplianceExperience';

export const useIsBillingHistoryEnabled = (): boolean => {
  const experience = useComplianceExperience();

  return experience.billing.historyEnabled;
};
